import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const UserClientUpdatePage = lazy(() => import('../views/update/UserClientUpdatePage'));

export function UserClientUpdatePageLazy() {
	return (
		<PageSuspense>
			<UserClientUpdatePage />
		</PageSuspense>
	);
}
